const tryGetJson = (input, logWarning) => {
  let output = null;
  try {
    output = JSON.parse(input);
  } catch {
    logWarning(`Invalid JSON found in markup: "${input}"`);
  }

  return output;
};

export default tryGetJson;
